import React, { useEffect, useState } from "react";
import "./Vehicles.css";
import { Link, NavLink } from "react-router-dom";
import { Button, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, Pagination, Stack, Typography } from "@mui/material";
import ViewAdminVehicle from "../../../components/Modal/ViewAdminVehicle";
import Loader from "../../../components/Utilities/Loader/Loader";
import { toast } from "react-toastify";
import EditVehicle from "../../../components/Modal/Supplier/Vehicle/EditVehicle";
import ViewGasHistory from "../../../components/Modal/Supplier/Vehicle/ViewGasHistory";
import axiosInstanceAdmin from "../../../hooks/axiosInstanceAdmin";

export default function Vehicles() {
  const [vehicles, setVehicles] = useState([]);
  const [filter, setFilter] = useState("");
  const [show, setShow] = useState(false);
  const [showEdit, setShowEdit] = useState(false);
  const [showRefill, setShowRefill] = useState(false);
  const [showHistory, setShowHistory] = useState(false);
  const [refreshKey, setRefreshKey] = useState(0);
  const [loading, setLoading] = useState(false);
  const [currentVehicle, setCurrentVehicle] = useState(null);
  const [isDeleteLoading, setIsDeleteLoading] = useState(false);
  const [deleteOpen, setDeleteOpen] = useState(false);

  //  state for pagination
  const [page, setPage] = useState(1);
  const [perPage, setPerPage] = useState(10);
  const [pageCount, setPageCount] = useState(1);

  //  pagination function
  const handlePageChange = (event, value) => {
    setPage(value);
  };

  const handleShow = () => setShow(true);

  const handleShowEdit = (data) => {
    setCurrentVehicle(data);
    setShowEdit(true);
  };

  const handleShowRefill = (data) => {
    setCurrentVehicle(data);
    setShowRefill(true);
  }

  const handleShowHistory = (data) => {
    setCurrentVehicle(data);
    setShowHistory(true);
  }

  const handleClose = () => {
    setShow(false);
    setShowEdit(false);
    setShowRefill(false)
    setShowHistory(false)
  };
  const handleRefresh = () => {
    setRefreshKey((prevRefreshKey) => prevRefreshKey + 1);
  };

  const handleFilterChange = (event) => {
    setFilter(event.target.value);
  };

  const handleDeleteOpen = async (data) => {
    await setCurrentVehicle(data);
    await setDeleteOpen(true);
  };

  const handleDeleteClose = () => {
    setDeleteOpen(false);
  };

  const fetchVehicles = () => {
    setLoading(true);
    axiosInstanceAdmin
      .get(
        `/admin/supplier/vehicle?page=${page}&limit=${perPage}&filter=${filter}`
      )
      .then((response) => {
        setVehicles(response.data.data.data);
        const pageCount = Math.ceil(
          response.data.data.total / response.data.data.per_page
        );
        setPageCount(pageCount);
      })
      .catch((err) => {
        toast.error("An error occured. Please, try again");
      })
      .finally(() => setLoading(false));
  };

  const handleDelete = () => {
    setLoading(true);
    axiosInstanceAdmin
      .delete(
        `/user/supplier/vehicle/${currentVehicle?.id}`
      )
      .then((response) => {
        toast.success("Vehicle deleted successfully")
        setDeleteOpen(false)
        handleRefresh()
      })
      .catch((err) => {
        toast.error("An error occured. Please, try again");
      })
      .finally(() => setLoading(false));
  };

  const filterVehicle = () => {
    fetchVehicles();
  };

  useEffect(() => {
    fetchVehicles();
  }, [page, perPage, refreshKey]);


  return (
    <>
      <div className="pagetitle">
        <h1>Vehicles</h1>
        <nav>
          <ol className="breadcrumb">
            <li className="breadcrumb-item">
              <NavLink to="/app/dashboard">Dashboard</NavLink>
            </li>
            <li className="breadcrumb-item active">Vehicle</li>
          </ol>
        </nav>
      </div>

      <section className="section vehicle">
        <div className="row">
          <div className="col-lg-12 col-md-12 order-2 order-sm-1 grid-margin stretch-card">
            <div className="card">
              <div className="card-body">
                <div className="d-flex justify-content-between">
                  <div>
                    <h4 className="card-title d-flex align-items-center">
                      Vehicles
                    </h4>
                  </div>
                  {/* <div>
                    <button
                      className="vehicle-button mt-3 btn btn-primary"
                      onClick={handleShow}
                    >
                      <i className="mdi mdi-plus-circle-outline"></i> New
                      Vehicle
                    </button>
                  </div> */}
                </div>

                {/* Filter input */}
                <div className="row mb-3">
                  <div className="col-lg-3">
                    <div className="input-group">
                      <input
                        type="text"
                        className="form-control"
                        placeholder="Search..."
                        value={filter}
                        onChange={handleFilterChange}
                      />
                      <button
                        onClick={filterVehicle}
                        className="btn btn-primary"
                        type="submit"
                      >
                        Go
                      </button>
                    </div>
                  </div>
                </div>

                {vehicles && vehicles.length > 0 ? (
                  <>
                    {/* <!-- Start Table --> */}
                    <div className="scroll-area-lg">
                      <div className="table-responsive-sm">
                        <table className="table table-striped table-borderless table-hover ">
                          <thead>
                            <tr>
                              <th scope="col">#</th>
                              <th scope="col">Brand Name</th>
                              <th scope="col">Created by</th>
                              <th scope="col">Model</th>
                              <th scope="col">Year manufactured</th>
                              <th scope="col">Color</th>
                              <th scope="col">Capacity (kg)</th>
                              <th scope="col">Gas Quantity (kg)</th>
                              <th scope="col">Status</th>
                              <th scope="col" width="5%"></th>
                            </tr>
                          </thead>
                          <tbody>
                            {vehicles.map((vehicle, i) => (
                              <tr key={vehicle.id}>
                                <th scope="row">{i + 1}</th>
                                <td>{vehicle.brand_name}</td>
                                <td>{vehicle.supplier?.last_name} {vehicle.supplier?.first_name}</td>
                                <td>{vehicle.model}</td>
                                <td>{vehicle.year_manufactured}</td>
                                <td>{vehicle.color}</td>
                                <td>{vehicle.capacity}</td>
                                <td>{vehicle.quantity ? vehicle.quantity : '-'}</td>
                                <td>
                                  <span
                                    className={`badge text-capitalize ${
                                      vehicle.status == "active"
                                        ? "bg-success"
                                        : "bg-danger"
                                    }`}
                                  >
                                    {vehicle.status}
                                  </span>
                                </td>
                                <td className="dropdown">
                                  <Link
                                    className="dropdown-toggle menu"
                                    id={`actionDropdown_${vehicle.id}`}
                                    href="#"
                                    data-bs-toggle="dropdown"
                                    aria-expanded="false"
                                  >
                                    <i className="mdi mdi-apps"></i>
                                  </Link>
                                  <div
                                    className="dropdown-menu dropdown-menu-right preview-list"
                                    aria-labelledby={`actionDropdown_${vehicle.id}`}
                                  >
                                    <Link
                                      className="dropdown-item custom-drop"
                                      onClick={() => handleShowEdit(vehicle)}
                                    >
                                      <i className="mdi mdi-pencil mr-2 text-success"></i>{" "}
                                      <span>Edit</span>
                                    </Link>
                                    <div className="dropdown-divider"></div>
                                    {/* <Link
                                      className="dropdown-item custom-drop"
                                      onClick={() => handleShowRefill(vehicle)}
                                    >
                                      <i className="mdi mdi-fire mr-2 text-info"></i>{" "}
                                      <span>Gas Refill</span>
                                    </Link> */}
                                    <div className="dropdown-divider"></div>
                                    <Link
                                      className="dropdown-item custom-drop"
                                      onClick={() => handleShowHistory(vehicle)}
                                    >
                                      <i className="mdi mdi-clock mr-2 text-warning"></i>{" "}
                                      <span>Gas History</span>
                                    </Link>
                                    <div className="dropdown-divider"></div>
                                    <Link className="dropdown-item custom-drop" onClick={() => handleDeleteOpen(vehicle)}>
                                      <i className="bi bi-trash-fill text-danger"></i>{" "}
                                      <span>Delete</span>
                                    </Link>
                                  </div>
                                </td>
                              </tr>
                            ))}
                          </tbody>
                        </table>
                      </div>
                    </div>
                    <div className="d-flex justify-content-end mt-2">
                      <div className="d-flex">
                        per page
                        <select
                          className="ml-1"
                          name="perPage"
                          onChange={(e) => setPerPage(e.target.value)}
                          value={perPage}
                        >
                          <option value="5">5</option>
                          <option value="10">10</option>
                          <option value="15">15</option>
                          <option value="25">25</option>
                          <option value="50">50</option>
                        </select>
                      </div>
                      <Pagination
                        onChange={handlePageChange}
                        count={pageCount}
                        color="primary"
                        shape="rounded"
                        size="small"
                        page={page}
                      />
                    </div>
                    {/* <!-- End Table --> */}
                  </>
                ) : (
                  <div className="alert alert-info mt-4">No record found</div>
                )}
              </div>
            </div>
          </div>
        </div>

        {/* <CreateVehicle
          show={show}
          closeModal={handleClose}
          refreshPage={handleRefresh}
        /> */}
        {currentVehicle && <EditVehicle
          show={showEdit}
          closeModal={handleClose}
          refreshPage={handleRefresh}
          currentVehicle={currentVehicle}
        />}
        {/* {currentVehicle && <RefillVehicle
          show={showRefill}
          closeModal={handleClose}
          refreshPage={handleRefresh}
          currentVehicle={currentVehicle}
        />} */}
        {currentVehicle && <ViewGasHistory
          show={showHistory}
          closeModal={handleClose}
          refreshPage={handleRefresh}
          currentVehicle={currentVehicle}
        />}

        {/* Delete Dialog */}
        {currentVehicle && (
          <>
            <Dialog
              open={deleteOpen}
              onClose={handleDeleteClose}
              aria-labelledby="alert-dialog-title"
              aria-describedby="alert-dialog-description"
            >
              <DialogTitle id="alert-dialog-title">
                Delete <b className="text-primary">{currentVehicle.brand_name} {currentVehicle.model}</b>{" "}
              </DialogTitle>
              <DialogContent>
                <DialogContentText id="alert-dialog-description">
                  Are you sure you want to perform this operation?
                </DialogContentText>
              </DialogContent>
              <DialogActions>
                <Button className="text-danger" onClick={handleDeleteClose}>
                  Cancel
                </Button>
                <Button onClick={handleDelete} autoFocus>
                  Continue
                </Button>
              </DialogActions>
              {isDeleteLoading && <Loader />}
            </Dialog>
          </>
        )}

        {loading && <Loader />}
      </section>
    </>
  );
}
